import { Diamond } from "@/components/Reveal";

const ITEMS = ["GEBÄUDEUNTERHALT", "UNTERHALTSREINIGUNG", "WINTERSERVICE", "SPEZIALREINIGUNG", "GARTENARBEITEN", "ENTSORGUNG"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="marquee-wrap overflow-hidden border-y border-slate-200 bg-[#F8FAFC] py-5" aria-hidden="true">
      <div className="marquee-track items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-editorial text-lg sm:text-xl font-light tracking-[0.2em] text-slate-400">{item}</span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
}
